import { lineString } from '@turf/helpers'
import length from '@turf/length'
export function getDistanceFrom(lan1, lat1, lan2, lat2) {
  const line = lineString([[lan1, lat1], [lan2, lat2]])
  const distance = length(line) * 1000
  return distance
}
